import { memo } from 'react';
import styles from './StockIndicatorContent.module.css';

const StockIndicatorContent = ({
    lineIndicator,
    hideBranchCode,
    hasMoreInfo,
    location,
}: {
    lineIndicator: boolean;
    hideBranchCode: boolean;
    hasMoreInfo: boolean;
    location: string;
}) => {
    if (lineIndicator) {
        return null;
    }

    if (hasMoreInfo) {
        return <span className={styles.infoIcon}>i</span>;
    }

    if (hideBranchCode) {
        return null;
    }

    return <>{location}</>;
};

export default memo(StockIndicatorContent);
